import { render, staticRenderFns } from "./HSCodesFilter.vue?vue&type=template&id=2f0764a0&scoped=true"
import script from "./HSCodesFilter.vue?vue&type=script&lang=js"
export * from "./HSCodesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0764a0",
  null
  
)

export default component.exports